import { render } from "./IconMoney.vue?vue&type=template&id=4f72d94f"
import script from "./IconMoney.vue?vue&type=script&lang=js"
export * from "./IconMoney.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__